<template>
  <div>
    <a-title
      :text="$t('reporting.significantEvents')"
    />
    <l-rows>
      <l-rows-row content-position="right">
        <a-button
          :text="$t('reporting.createSignificantEvent')"
          variant="primary"
          @click="handleCreate"
        />
      </l-rows-row>
      <o-list
        :data="page.significantEvents"
        :columns="columns"
        :loading="pageMeta.loading"
        :limit="limit"
        :offset="offset"
        :total="page.totalCount"
        @page-change="handlePageChange"
      />
    </l-rows>
  </div>
</template>

<script>
  import { AButton, ATitle, LRows, LRowsRow, OList } from 'codefabrik-gui-vue'
  import { reportingService } from '@/services'
  import useQuery from 'codefabrik-gui-vue/src/apollo/mixins/useQuery'
  import { formatDateTime } from '@/shared'

  export default {
    name: 'SignificantEventList',
    components: { LRows, LRowsRow, ATitle, OList, AButton },
    data () {
      return {
        offset: 0,
        limit: 0
      }
    },
    computed: {
      columns () {
        return [
          {
            header: this.$t('common.username'),
            field: 'username',
          },
          {
            header: this.$t('common.description'),
            field: 'description',
            size: '4'
          },
          {
            header: this.$t('common.happenedAt'),
            field: 'happenedAt',
            filter: formatDateTime
          },
          {
            header: this.$t('common.createdAt'),
            field: 'createdAt',
            filter: formatDateTime
          },
        ]
      }
    },
    methods: {
      handlePageChange (pageNumber) {
        this.offset = (pageNumber - 1) * this.limit
      },
      handleCreate () {
        this.$router.push({ name: 'significant-event-create' })
      }
    },
    mixins: [
      useQuery({
        name: 'page',
        serviceFn: reportingService.getSignificantEventPage,
        variables () {
          return {
            input: {
              limit: this.limit,
              offset: this.offset
            }
          }
        }
      })
    ]
  }
</script>

<style scoped>

</style>
